import { Component, Input } from '@angular/core';

@Component({
    selector: 'rg-sortable-item',
    template: `
    <div class="sortable-item">
        <div class="item-title">
            <i [ngClass]="item[iconExpr]" aria-hidden="true" *ngIf="item[iconExpr]"></i>
            {{item[displayExpr]}}
        </div>
    </div>
    `,
    styles: [`:host{display:block;position:relative;--border:1px solid #ddd;--box-shadow:0 4px 8px -5px #9a9494;background-color:#fff;--width:100%}.item-title{--drag-visible:none;margin:0;padding-left:10px}.item-title:hover{--drag-visible:inline-block}.item-title .handler{color:#919191;display:var(--drag-visible)}.drag-image{position:absolute;z-index:-1;background-color:#fff;border:2px solid #d6cfcf;box-sizing:border-box;pointer-events:none}:host(.safari-specific) .drag-image{position:fixed;bottom:0}`]
})
export class SortableItemComponent {
    @Input() item: any;
    @Input() displayExpr: string;
    @Input() iconExpr: string;
}
